import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { Client } from "interfaces/client";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_CLIENTS_CNPJ_" }
);

export interface ListClientsCnpjState extends IState {
  data: Client[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: Client[];
}

const INITIAL_STATE: ListClientsCnpjState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListClientsCnpjState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ListClientsCnpjState,
  action: ISuccessListUnitsAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListClientsCnpjState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listClientsCnpj = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListClientsCnpjTypes = Types;
export const ListClientsCnpjActions = Creators;
